import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    addToCart: any;
    constructor(public http: HttpClient, public snackBar: MatSnackBar) { }
} 